import { LoadableAfterPaint } from '@confluence/loadable';

export default LoadableAfterPaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-EditorTeamCreatedFlag" */ './EditorTeamCreatedFlag'),
});
